/* ---- VC issue button handler ----
 * Opens System B URL with GET parameters for VC issuance.
 *
 * 設定: .env (または .env.local) の VITE_VC_ISSUER_URL で上書き可能。
 * 未設定時は開発用プレースホルダを使用。
 */

import { authService } from '../services/auth.service';
import type { EventDetail } from '../types';

const VC_ISSUER_BASE: string =
  import.meta.env.VITE_VC_ISSUER_URL ?? 'https://vc-issuer.example.com/issuer_endpoint/';

export function issueVc(event: EventDetail): void {
  const user = authService.getUser();
  const uuid = user?.device_uuid || '';

  const params = new URLSearchParams({
    uuid,
    event_id: String(event.id),
    event_type: event.type,
    start_hash: event.start_hash,
    end_hash: event.end_hash,
  });

  if (event.fence_id) {
    params.set('geofence_id', event.fence_id);
  }
  if (event.fence) {
    params.set('geofence_name', event.fence);
  }

  const url = `${VC_ISSUER_BASE}?${params.toString()}`;
  window.open(url, '_blank');
}
